/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verifying_TextInputs */



/**
* | output |
* | --- |
* | "Please wait while we verify your subscription..." |
*
* @param {Creator_Checkout_Verifying_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verifying_text = /** @type {((inputs?: Creator_Checkout_Verifying_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verifying_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez patienter pendant la verification de votre abonnement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte warten Sie, während wir Ihr Abonnement überprüfen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attendi mentre verifichiamo la tua iscrizione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, подождите, пока мы проверим вашу подписку...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor espere mientras verificamos su suscripción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请稍候，我们正在验证您的订阅信息……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションを確認中です。しばらくお待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया प्रतीक्षा करें जब तक हम आपकी सदस्यता की पुष्टि नहीं कर लेते...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aguarde enquanto verificamos sua assinatura...")
	return /** @type {LocalizedString} */ ("Please wait while we verify your subscription...")
});